/*
 * Copyright (c) 2024 by Guangdong Sun Railway Information Technology, Inc. 
 * All Rights Reserved.
 *  
 * @Author: Dlx
 * @Date: 2024-08-26 14:58:05
 * 
 * @LastEditors: DESKTOP-02E09R4\admin dinglongxin@sunengineering.cn
 * @LastEditTime: 2024-10-23 16:59:49
 * 
 * @Description: 
 * 
 */ 
import './App.css'
import IfcViewerDemo from './pages/ifcViewerDemo/Index'

function App() { 

  return (
    <> 
      <IfcViewerDemo />
    </>
  )
}

export default App
